function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M10.006 8.962a.909.909 0 01-.683.494l-4.46.648 3.226 3.125a.9.9 0 01.262.8l-.761 4.413 3.987-2.085a.914.914 0 01.846 0l3.987 2.085-.76-4.413a.9.9 0 01.26-.8l3.227-3.125-4.46-.648a.909.909 0 01-.683-.494L12 4.946l-1.994 4.016zM8.587 7.736l2.598-5.232a.911.911 0 011.63 0l2.598 5.232 5.808.844a.902.902 0 01.503 1.542l-4.202 4.07.992 5.75c.127.738-.653 1.3-1.32.952L12 18.178l-5.195 2.716c-.666.349-1.446-.214-1.319-.953l.992-5.75-4.202-4.07a.902.902 0 01.503-1.54l5.808-.845z"
});

var SvgStar = function SvgStar(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/star.5b543eff.svg";
export { SvgStar as ReactComponent };